import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';
const Heading = dynamic(()=>import('../Heading/Heading'))
import { createHtmlFriendlyId, getReviewAndRatingId, onClickBuyNow, stripHtml } from '../../adapters/helpers/Utils'
const Image = dynamic(()=>import('../Image/Image'))
const ObLink = dynamic(()=>import('../ObLink/ObLink'))
const Icon = dynamic(()=>import('../Icon/Icon'))
const RichText = dynamic(()=>import('../RichText/RichText'))
import { LegacyProductHighlightsConstants, Constants, miniContentBlockConstants } from '../../adapters/helpers/Constants';
import { mediaQueryHOC, updateCurrentProductIndex } from '../../adapters/helpers/Hooks';
import { getColorStyle } from '../../adapters/helpers/Utils';
const Button = dynamic(() => import('../Button/Button'))
import { handleColorNameFormat } from '../../adapters/helpers/Utils'
import PdpShowMoreAccordion from './PdpShowMoreAccordion/PdpShowMoreAccordion'
import { optimizeImage } from '../../adapters/helpers/pagespeedHelper'
import DOMPurify from 'isomorphic-dompurify'
import C from 'classnames'

function LegacyProductHighlights(props) {
    const {extraAttributes, isMedium, document:doc} = props;
    const [selectedVariantIndex, setSelectedVariantIndex] = useState(0);
    const [currentCarouselImageIndex, setCurrentCarouselImageIndex] = useState(0);
    // eslint-disable-next-line no-unused-vars
    const [_, setGlobalState] = updateCurrentProductIndex();
    const entity = extraAttributes.entity;
    const productOverview = entity.productOverview?.fields;
    const productVariants = productOverview?.productVariants;
    const legacyAssets = entity?.legacyAssets || [];
    const [carouselAssets, setCarouselAssets] = useState(legacyAssets);
    const [productHighlights, setProductHighlights] = useState(entity.productHighlights || []);
    const labels = doc?.fields
    const pressQuote = productOverview?.pressQuote?.fields
    const backgroundImage = doc.fields.background
    const findRetailerButtonLabel = productOverview?.buyNowLabel?.fields.text
    const anchorId = doc?.fields.anchorId
    let reviewAndRatingId = getReviewAndRatingId(entity.productOverview)
    const seeLessLabel = doc?.fields?.seeLessLabel?.fields?.text
    const seeMoreLabel = doc?.fields?.seeMoreLabel?.fields?.text
    const nextLabel = doc?.fields?.nextLabel?.fields?.text
    const previousLabel = doc?.fields?.previousLabel?.fields?.text.toUpperCase()
    const productVariantAttributeTypes = entity?.productVariantAttributeTypes || []
    const thumbnailCarouselRef = useRef()
    const comingSoonText = productOverview?.comingSoonLabel?.fields?.text || ''
    const comingSoonLink = productOverview?.comingSoonLink || ''
    const isDisableFindRetailer = productOverview?.deactivateBuyNowButton
    const isEnableCommingSoon = productOverview?.enableComingSoonLabel
    const poweredByLabel = productOverview?.poweredBy
    const [isPageLoaded, setIsPageLoaded] = useState(false)

    const TruncatedDescription = ({className, text}) => {
        const [seeLess, setSeeLess] = useState(true);
        const firstPeriodIndex = text.indexOf('.');

        // If there is no period or the text contains a single sentence.
        if (firstPeriodIndex === -1 || firstPeriodIndex + 2 === text.length) {
            return <div className={className} dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(text) }}></div>
        }

        return (
            <div className={className}>
                <div dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(seeLess ? `${text.slice(0, firstPeriodIndex + 1)}` : text)}}></div>

                <ObLink
                    ariaExpanded={seeLess ? false : true}
                    dataActionDetail={seeLess ? seeMoreLabel : seeLessLabel}
                    className='primaryGrey ob-product-highlights__see-more event_button_click'
                    onClick={() => setSeeLess(!seeLess)}
                    tag={LegacyProductHighlightsConstants.button}
                >
                    {seeLess ? seeMoreLabel : seeLessLabel}
                    <img alt='chevron-down' className='chevron-down' src={seeLess ? Constants.downIconPath : Constants.upIconPath}></img>
                </ObLink>
            </div>
        )
    }

    const renderHighlightsHeader = (tagType) => {
        let ele = ''
        if (isMedium) {
            ele = document.getElementById('ob-product-subnav-scroll')
        }

        let mediumClassName = isMedium ? 'ob-product-highlights__header_mobile' : 'ob-product-highlights__header_desktop'
        return (
            <div className={`ob-product-highlights__header ${mediumClassName}`} style={{ marginTop: ele?.offsetHeight + 'px' }}>
                <Heading tag={tagType} className={`ob-product-highlights__title`}>
                    {productOverview.title}
                </Heading>
                <button
                    className='ob-scroll-to-review-section event_product_review_view'
                    data-bv-show='inline_rating'
                    data-bv-product-id={reviewAndRatingId ? reviewAndRatingId.trim() : ''}
                    data-bv-seo='false'
                    id='rnrButton'
                    aria-label={stripHtml(productOverview?.title) ? `${stripHtml(productOverview?.title)} ${LegacyProductHighlightsConstants.productRating}` : LegacyProductHighlightsConstants.productRating}
                    data-action-detail={stripHtml(productOverview?.title)}
                ></button>
                {productOverview?.description && <TruncatedDescription className={'ob-product-highlights__description ob-product-highlights__description-mob'} text={productOverview.description} />}
            </div>
        )
    }

    useEffect(() => {
        setIsPageLoaded(true)
        setGlobalState({ currentProductId: selectedVariantIndex })
        if (productVariants && productVariants[selectedVariantIndex]?.fields?.legacyAssets) {
            setCarouselAssets(productVariants[selectedVariantIndex]?.fields?.legacyAssets)
        } else if (legacyAssets.length > 1) {
            setCarouselAssets(legacyAssets)
        }
    }, [selectedVariantIndex])

    const renderColorButtons = () => {
        return (
            <div className={'ob-product-highlights__color-ctn'}>
                {productVariants && productVariants.some((variant) => variant?.fields?.color !== undefined) && <p className={'ob-product-highlights__label'}>{labels.colorLabel}</p>}
                <ul className={'ob-product-highlights__colors'}>
                    {productVariants &&
                        productVariants
                            .filter((response) => response?.fields.color?.fields?.name)
                            .map((variant, index) => {
                                return (
                                    <li className='ob-product-highlights__selected-colors-item' key={index}>
                                        {!variant?.fields?.color?.fields?.colorImage ? (
                                            <button
                                                style={getColorStyle(variant?.fields.color)}
                                                className={`ob-product-highlights__color event_buy_now_choose_product ${index === selectedVariantIndex ? LegacyProductHighlightsConstants.isActive : LegacyProductHighlightsConstants.empty}`}
                                                onClick={() => {
                                                    setSelectedVariantIndex(index)
                                                    setCurrentCarouselImageIndex(0)
                                                }}
                                                data-action-detail={`${variant?.fields?.color?.fields?.name}_${stripHtml(productOverview?.title)}`}
                                                aria-pressed={index === selectedVariantIndex ? true : false}
                                            >
                                                <span className='visuallyhidden'>{variant?.fields.color?.fields.name}</span>
                                            </button>
                                        ) : (
                                            <img
                                                className={`event_buy_now_choose_product ob-series-product-highlights-color-img   ${index === selectedVariantIndex ? 'ob-series__color--active' : ''}`}
                                                data-action-detail={`${variant?.fields?.color?.fields?.name}_${stripHtml(productOverview?.title)}`}
                                                alt={variant?.fields?.color?.fields?.colorImage?.fields?.title}
                                                src={optimizeImage(variant?.fields?.color?.fields?.colorImage?.fields?.file?.url)}
                                                onClick={() => setSelectedVariantIndex(index)}
                                            ></img>
                                        )}
                                        {variant && variant?.fields && variant?.fields.color && (
                                            <div className='color-container-pdp'>
                                                <p className={index === selectedVariantIndex ? 'ob-accessibility-highlighted visuallyhidden' : 'ob-accessibility visuallyhidden'}>
                                                    {handleColorNameFormat(variant?.fields.color?.fields.name)}
                                                </p>
                                            </div>
                                        )}
                                    </li>
                                )
                            })}
                </ul>
            </div>
        )
    }

    useEffect(() => {
        if (carouselAssets && carouselAssets.length > 0) {
            let carouselAssetsData = carouselAssets
            let arrayOfData = []
            carouselAssetsData.filter((data, index) => {
                let indexVal = productHighlights && productHighlights.length > 0 ? productHighlights.findIndex((x) => x.fields.imageIndex == index) : -1
                if (indexVal === -1) {
                    if (data?.fields?.isHighlightHyperlink) {
                        data.fields.imageIndex = index
                        data.fields.selectedVariantIndex = selectedVariantIndex
                        arrayOfData.push(data)
                    }
                }
            })
            if (productHighlights && productHighlights.length > 0) {
                setProductHighlights([...productHighlights.filter((obj) => !obj.fields.hasOwnProperty('selectedVariantIndex')), ...arrayOfData])
            } else {
                setProductHighlights([...arrayOfData])
            }
        }
    }, [carouselAssets, selectedVariantIndex])

    const [showMore, setShowMore] = useState(false)

    const highlightList = productHighlights
        ? Object.keys(productHighlights)
              .slice(0, 1)
              .map((key) => {
                  let highLightStatus = productHighlights?.[key]?.fields?.isHighlightHyperlink || false
                  return (
                      <li key={key} className={`ob-product-highlights__highlights-list-item ${highLightStatus ? 'ob-hyperlink-highlights-li' : ''}`}>
                          {highLightStatus ? (
                              <p onClick={(e) => handleHyperLinkImage(productHighlights?.[key]?.fields?.imageIndex)} className='ob-highlight-hyperlink-list-item'>
                                  <Icon name={Constants.chevronRight} size={1.7} color={`${currentCarouselImageIndex === productHighlights?.[key]?.fields?.imageIndex ? miniContentBlockConstants.blueCtaColor : miniContentBlockConstants.highBlackCtaColor}`} />{' '}
                                  {productHighlights?.[key]?.fields?.highlightHyperlinkTitle || productHighlights?.[key]?.fields?.name}
                              </p>
                          ) : (
                              <RichText document={productHighlights[key]} />
                          )}
                      </li>
                  )
              })
        : []

    const highlightListMore = productHighlights
        ? Object.keys(productHighlights).map((key) => {
              let highLightStatus = productHighlights?.[key]?.fields?.isHighlightHyperlink || false
              return (
                  <li key={key} className={`ob-product-highlights__highlights-list-item more ${showMore} ${highLightStatus ? 'ob-hyperlink-highlights-li-more' : ''}`}>
                      {highLightStatus ? (
                          <p onClick={(e) => handleHyperLinkImage(productHighlights?.[key]?.fields?.imageIndex)} className='ob-highlight-hyperlink-list-item'>
                              <Icon name={'ovalArrowRight'} size={1.7} color={`${currentCarouselImageIndex === productHighlights?.[key]?.fields?.imageIndex ? miniContentBlockConstants.blueCtaColor : miniContentBlockConstants.highBlackCtaColor}`} />
                              {productHighlights?.[key]?.fields?.highlightHyperlinkTitle || productHighlights?.[key]?.fields?.name}
                          </p>
                      ) : (
                          <RichText document={productHighlights[key]} />
                      )}
                  </li>
              )
          })
        : []

    const handleHyperLinkImage = (imgIndex) => {
        setCurrentCarouselImageIndex(imgIndex)
        if (thumbnailCarouselRef.current) {
            const thumbnailChildren = thumbnailCarouselRef.current.children
            scrollElemIntoView(thumbnailChildren[imgIndex])
            let element = document.getElementById('ob-product-highlights-carousel')
            if (element && props.isSmall) {
                element.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' })
            }
        }
    }

    const highlightLength = () => {
        // Return true if highlight is superior than 2 to display see more button
        // return true
        return productHighlights && Object.keys(productHighlights).length > 1
    }

    const showMoreButton = () => {
        let button

        if (showMore) {
            button = (
                <ObLink
                    ariaExpanded={true}
                    className='primaryGrey ob-product-highlights__see-more recheck event_button_click'
                    tag={LegacyProductHighlightsConstants.button}
                    dataActionDetail={seeLessLabel}
                    onClick={handleShowMore}
                    ariaLabel={`${seeLessLabel} ${LegacyProductHighlightsConstants.highlights}`}
                >
                    {seeLessLabel.toUpperCase()}
                    <span className='visuallyhidden'>{LegacyProductHighlightsConstants.highlights}</span>
                    <img src={Constants.upIconPath}></img>
                </ObLink>
            )
        } else {
            button = (
                <ObLink
                    ariaExpanded={false}
                    className='primaryGrey ob-product-highlights__see-more event_button_click'
                    tag={LegacyProductHighlightsConstants.button}
                    dataActionDetail={seeMoreLabel}
                    onClick={handleShowMore}
                    ariaLabel={`${seeMoreLabel} ${LegacyProductHighlightsConstants.highlights}`}
                >
                    {seeMoreLabel.toUpperCase()}
                    <span className='visuallyhidden'>{LegacyProductHighlightsConstants.highlights}</span>
                    <img className='downimage' alt='chevron-down' src={Constants.downIconPath}></img>
                </ObLink>
            )
        }

        return button
    }

    const handleShowMore = () => {
        setShowMore(!showMore)
    }

    const renderShopByPack = (productVariants) => {
        return (
            <div className={'ob-product-highlights__dropdown-ctn'}>
                <ul className={'ob-product-highlights__dropdown-list'}>
                    {productVariantAttributeTypes.map((productVariantAttributeType, index) => (
                        <li key={index} className={'ob-product-highlights__dropdown-list-item'}>
                            <label htmlFor={createHtmlFriendlyId(productVariantAttributeType?.fields?.name)} className={'ob-product-highlights__label ob-product-highlights__dropdown-label'}>
                                {productVariantAttributeType?.fields?.description?.fields?.text}
                            </label>
                            <div className={'ob-product-highlights__dropdown-list-item-ctn'}>
                                <select
                                    id={createHtmlFriendlyId(productVariantAttributeType?.fields?.name)}
                                    className={'ob-product-highlights__dropdown-select'}
                                    onChange={(event) => {
                                        if (window && window.dataLayer) {
                                            window.dataLayer.push({
                                                event: 'customEvent',
                                                GAeventCategory: 'event_informational_action',
                                                GAeventAction: 'event_buy_now_choose_product',
                                            })
                                        }
                                        setSelectedVariantIndex(parseInt(event.currentTarget.value, 10))
                                        setCurrentCarouselImageIndex(0)
                                    }}
                                >
                                    {productVariants &&
                                        productVariants.map((variant, variantIndex) => {
                                            let productVariantAttributes = variant?.fields?.productVariantAttributes

                                            if (productVariantAttributes != null && productVariantAttributes.length > index) {
                                                if (productVariantAttributeType?.fields?.name === productVariantAttributes[index]?.fields?.productVariantAttributeTypeReference?.fields?.name) {
                                                    return (
                                                        <option key={variantIndex} value={variantIndex}>
                                                            {variant?.fields?.productVariantAttributes[index]?.fields?.description?.fields?.text}
                                                        </option>
                                                    )
                                                }
                                            } else {
                                                console.info('Product Variant Attr Type ' + productVariantAttributeType?.fields?.name + ' missing at index ' + index + ' for variant ' + variant?.fields?.name)
                                                return ''
                                            }
                                        })}
                                </select>
                                <div className={'ob-product-highlights__dropdown-icon'}>
                                    <Icon name={'chevronDown'} size={2} />
                                </div>
                            </div>
                        </li>
                    ))}
                </ul>
            </div>
        )
    }

    const handleCarouselSlideChange = ({ position = '', index = -1 }) => {
        if (thumbnailCarouselRef.current) {
            let carouselIndex = currentCarouselImageIndex
            if (position === LegacyProductHighlightsConstants.prev && carouselIndex > 0) {
                carouselIndex--
            } else if (position === LegacyProductHighlightsConstants.next && carouselIndex < carouselAssets?.length - 1) {
                carouselIndex++
            } else if (index > -1) {
                carouselIndex = index
            }
            setCurrentCarouselImageIndex(carouselIndex)

            const thumbnailChildren = thumbnailCarouselRef.current.children
            scrollElemIntoView(thumbnailChildren[carouselIndex])
        }
    }

    const scrollElemIntoView = (elem) => {
        if (!elem) {
            return
        }
        elem.scrollIntoView({
            behavior: LegacyProductHighlightsConstants.smooth,
            block: LegacyProductHighlightsConstants.nearest,
            inline: LegacyProductHighlightsConstants.center,
        })
    }

    let startTouchPoint = null
    let endTouchPoint = null

    const onTouchStart = (event) => {
        endTouchPoint = null

        if (event.touches) {
            startTouchPoint = event.touches[0]
        }
    }

    const onTouchEnd = () => {
        if (endTouchPoint != null && startTouchPoint != null) {
            let deltaX = startTouchPoint.screenX - endTouchPoint.screenX
            let deltaY = startTouchPoint.screenY - endTouchPoint.screenY

            if (deltaX > 0 && !isVerticalScroll(deltaX, deltaY)) {
                handleCarouselSlideChange({ position: LegacyProductHighlightsConstants.next })
            } else {
                handleCarouselSlideChange({ position: LegacyProductHighlightsConstants.prev })
            }
        }
    }

    const onTouchMove = (event) => {
        if (event.touches) {
            endTouchPoint = event.touches[0]
        }
    }

    const isVerticalScroll = (deltaX, deltaY, deltaThreshold = 10) => {
        let moveX = Math.abs(deltaX) > deltaThreshold ? Math.abs(deltaX) : 0
        let moveY = Math.abs(deltaY) > deltaThreshold ? Math.abs(deltaY) : 0

        return moveY > moveX
    }

    const renderCarousel = () => {
        return (
            <div className={'ob-product-highlights__carousel'} id='ob-product-highlights-carousel'>
                <ul className={'ob-product-highlights__carousel-main-list'} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} onTouchMove={onTouchMove}>
                    {carouselAssets.map((carouselMainAsset, index) => (
                        <li key={index} data-index={index} className={`ob-product-highlights__carousel-main-list-item ${currentCarouselImageIndex === index ? '--is-active' : ''}`}>
                            <Image image={carouselMainAsset} alt={carouselAssets?.[index]?.fields?.alternateText} noLazyLoad={true} />
                        </li>
                    ))}
                </ul>

                <div className={'ob-product-highlights__carousel-thumbnail-ctn'}>
                    <ul className={'ob-product-highlights__carousel-thumbnail-list'} ref={thumbnailCarouselRef}>
                        {carouselAssets.map((carouselThumbnailItem, index) => {
                            return (
                                <li
                                    key={index}
                                    className={`ob-product-highlights__carousel-thumbnail-list-item ${carouselThumbnailItem?.imageRendition?.aspectRatio !== 1 ? 'ob-product-highlights__carousel-thumbnail-list-item--not-square' : ''}`}
                                >
                                    <button
                                        type={'button'}
                                        aria-label={carouselAssets?.[index]?.fields?.alternateText}
                                        className={`ob-product-highlights__carousel-thumbnail-button ${currentCarouselImageIndex === index ? '--is-active' : ''} event_image_click`}
                                        data-action-detail={`${carouselAssets?.[index]?.fields?.alternateText} -${index}-thumbnail`}
                                        onClick={() => handleCarouselSlideChange({ index: index })}
                                    >
                                        <Image image={carouselThumbnailItem} altText={carouselThumbnailItem?.fields?.alternateText ? `${carouselThumbnailItem.fields.alternateText} ${index + 1}` : null} />
                                    </button>
                                </li>
                            )
                        })}
                    </ul>
                    <button
                        type={'button'}
                        className={`ob-product-highlights__carousel-btn ob-product-highlights__carousel-btn--prev ${currentCarouselImageIndex === 0 ? '--is-disabled' : ''} event_button_click`}
                        onClick={() => handleCarouselSlideChange({ position: LegacyProductHighlightsConstants.prev })}
                        aria-label={previousLabel}
                        data-action-detail={'productCarousel-previous-button'}
                        tabIndex={currentCarouselImageIndex === 0 ? -1 : null}
                        disabled={currentCarouselImageIndex === 0 ? true : false}
                    >
                        <img className='lefticon' alt='ProductCarousel-left-arrow' src={Constants.leftIconPath}></img>
                    </button>
                    <button
                        type={'button'}
                        className={`ob-product-highlights__carousel-btn ob-product-highlights__carousel-btn--next ${currentCarouselImageIndex === carouselAssets?.length - 1 ? '--is-disabled' : ''} event_button_click`}
                        onClick={() => handleCarouselSlideChange({ position: LegacyProductHighlightsConstants.next })}
                        aria-label={nextLabel}
                        data-action-detail={'productCarousel-next-button'}
                        tabIndex={currentCarouselImageIndex === carouselAssets?.length - 1 ? -1 : null}
                        disabled={currentCarouselImageIndex === carouselAssets?.length - 1 ? true : false}
                    >
                        <img className='lefticon' alt='ProductCarousel-right-arrow' src={Constants.rightIconPath}></img>
                    </button>
                </div>
            </div>
        )
    }

    const renderShopNowCTA = () => {
        let comingSoonBtnLink = productVariants[selectedVariantIndex]?.fields?.comingSoonLink ? productVariants[selectedVariantIndex]?.fields?.comingSoonLink : comingSoonLink
        return (
            <Button
                tag={'a'}
                disabled={!comingSoonBtnLink}
                href={comingSoonBtnLink}
                size={'medium-long'}
                target={'_blank'}
                className={C('ob-product-highlights__buy-now-btn-style-primary event_buy_now_eretailer_exit')}
                dataActionDetail={`dtc_${stripHtml(productOverview.title)}`}
                onClick={(event) => {
                    props.onClickCallback(event)
                    onClickBuyNow(comingSoonLink)
                }}
                dataEventBin={true}
                dataProductTitle={stripHtml(productOverview.title)}
                rel='noopener noreferrer'
            >
                {comingSoonText}
            </Button>
        )
    }

    const renderFindRetailerCTA = () => {
        const btnClassName = isEnableCommingSoon ? 'ob-product-highlights__find-retailer-btn-style-secondary' : ''
        return (
            findRetailerButtonLabel &&
            !isDisableFindRetailer &&
            productVariants &&
            productVariants[selectedVariantIndex]?.fields?.sku && (
                <Button
                    size={'medium-long'}
                    tag={isEnableCommingSoon ? 'a' : 'button'}
                    textTheme={isEnableCommingSoon}
                    className={`${btnClassName} event_buy_now`}
                    dataActionDetail={`open_ps_panel_${stripHtml(productOverview.title)}`}
                    onClick={(event) => props.onClickCallback(event)}
                    sku={productVariants[selectedVariantIndex]?.fields?.sku}
                >
                    {findRetailerButtonLabel}
                </Button>
            )
        )
    }

    const renderTextContent = () => {
        return (
            <div className={'ob-product-highlights__text-content'}>
                {!isMedium && renderHighlightsHeader('h1')}
                {isMedium && productVariants && renderColorButtons()}
                {productOverview?.description && <TruncatedDescription className={'ob-product-highlights__description'} text={productOverview.description} />}
                {pressQuote && (
                    <div className={'ob-product-highlights__quote'}>
                        <span className={'ob-product-highlights__quote-text'}>{pressQuote.quote}</span>
                        <Image image={pressQuote.pressLogo} />
                    </div>
                )}
                {!isMedium &&
                    productVariants &&
                    productVariants?.some((variant) => {
                        return variant?.fields?.color !== undefined
                    }) &&
                    renderColorButtons()}

                {productVariants && productVariantAttributeTypes.length > 0 && renderShopByPack(productVariants)}

                <div className={'ob-product-highlights__purchase-btn-section ob-product-highlights__purchase-btn-section--legacy'}>
                    {isEnableCommingSoon && (
                        <div>
                            {renderShopNowCTA()}
                            {poweredByLabel && <p className='ob-product-highlights__powered-by-label'>{poweredByLabel}</p>}
                        </div>
                    )}
                    {renderFindRetailerCTA()}
                </div>
                {productHighlights && productHighlights.length > 0 && (
                    <div className={'ob-product-highlights__highlights-ctn'}>
                        <h3 className={'ob-product-highlights__label'}>{labels.highlightsLabel}</h3>
                        <ul className={'ob-product-highlights__highlights-list'} id={'ob-highlights-ctn'}>
                            {!showMore && highlightList}
                            {showMore && highlightListMore}
                        </ul>
                        {highlightLength() && showMoreButton()}
                    </div>
                )}
                <div className='mobile-pdp-showmore'>
                    <PdpShowMoreAccordion productHighlights={productHighlights}></PdpShowMoreAccordion>
                </div>
            </div>
        )
    };

    if(productVariants &&  productVariants[0]?.fields?.mainAsset?.fields){
        productVariants[0].fields.mainAsset.fields['isProductPage'] = true;
    }else if(productOverview?.mainAsset?.fields){
        productOverview.mainAsset.fields['isProductPage'] = true;
    }
    return (
        <div className={'ob-product-highlights ob-legacy-product-highlights'} id={anchorId}>
            <Image image={backgroundImage}>
                <div className={'ob-product-highlights__ctn'}>
                    {/* Below code structure have implemented for pagespeed. */}
                    {isPageLoaded ? isMedium && renderHighlightsHeader('h1') : <div className='ob-mobile-legacy-product-highlights-header'>{renderHighlightsHeader('h2')}</div>}
                    {carouselAssets.length > 0 ? (
                        renderCarousel()
                    ) : (
                        <ul className={'ob-product-highlights__img-ctn'}>
                            {productVariants ? (
                                productVariants.map((variant, index) => (
                                    <li className={`ob-product-highlights__img ${index === selectedVariantIndex ? LegacyProductHighlightsConstants.isActive : LegacyProductHighlightsConstants.empty}`} key={index}>
                                        {productOverview.mainAsset ? <Image image={productOverview.mainAsset} noLazyLoad={true} /> : <Image image={variant.fields.mainAsset} noLazyLoad={true} />}
                                    </li>
                                ))
                            ) : (
                                    <li>
                                        <Image image={productOverview.mainAsset} noLazyLoad={true} />
                                    </li>
                                )}
                        </ul>
                    )}
                    {!isMedium && renderTextContent()}
                </div>
            </Image>
            {isMedium && renderTextContent()}
        </div>
    )
}

export default mediaQueryHOC(LegacyProductHighlights);
// This export is for unit testing (do not remove) :
export const LegacyProductHighlightsTest = LegacyProductHighlights;

LegacyProductHighlights.propTypes = {
    extraAttributes: PropTypes.object,
    isMedium: PropTypes.bool,
    document: PropTypes.object,
    onClickCallback: PropTypes.func,
    className: PropTypes.string,
    text: PropTypes.string,
};
